export default __webpack_public_path__ + "static/nwilliams-288d499bc92b844a74ac694413e9dd60.png";